import React from 'react';
import T from 'prop-types';
// styles
import classnames from 'classnames/bind';
import styles from './LadderLogo.mod.css';

let cx = classnames.bind(styles);

const LadderLogo = ({ color, style, size }) => (
  <div
    className={cx('logo')}
    style={{
      width: `${size}px`,
      height: `${size}px`,
      background: color,
      ...style
    }}
  />
);

LadderLogo.propTypes = {
  size: T.number,
  style: T.object
};

export default LadderLogo;



// WEBPACK FOOTER //
// ./src/components/LadderLogo/LadderLogo.js